import PriceModelBase from '../_generated/modelBases/price-model-base';

export default class PriceModel extends PriceModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
